import { NgModule, Optional, SkipSelf,ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
//import { HeaderComponent } from './header/header.component';
import { UserService } from './services/user.service';
import { ProjectService } from './services/project.service';
import { JobService } from './services/job.service';
import { LoaderService } from './services/loader.service';
import { StudioService } from './services/studio.service';
import { TeamService } from './services/team.service';
import { OfferService } from './services/offer.service';
import { ProductService } from './services/product.service';
import { MediaService } from './services/media.service';
import { DocumentSegmentService } from './services/documentSegment.service';
import { PermissionsService } from './services/permissions.service';
import { AuthGuardService } from './services/auth-guard.service';
import { FileUploaderService } from './services/file-uploader.service';
// import { AngularFireAuthModule } from 'angularfire2/auth';
// import { AngularFireModule } from 'angularfire2';
import { MessagingService } from './services/messaging.service';
import { ReportService } from './services/report.service';
// animations


// interceptors
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '@app/core/services/token.interceptor';
import { ErrorsHandler } from '@app/core/services/errors-handler';
import { environment } from './../../environments/environment';

// import * as firebase from 'firebase';

// firebase.initializeApp(environment.firebase);


@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    HttpClientModule,
    // AngularFireAuthModule,
    // AngularFireModule.initializeApp(environment.firebase),
  ],
  declarations: [],
  exports: [
  ],
  providers: [
    UserService,
    ProjectService,
    JobService,
    LoaderService,
    StudioService,
    TeamService,
    OfferService,
    DocumentSegmentService,
    PermissionsService,
    AuthGuardService,
    ProductService,
    MediaService,
    MessagingService,
    ReportService,
    FileUploaderService,
    {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler,
    }

  ]
})
export class CoreModule {

  constructor(
      @Optional()
      @SkipSelf()
      parentModule: CoreModule
    ) {
      if (parentModule) {
        throw new Error('CoreModule is already loaded. Import only in AppModule');
      }
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/core.module.ts